import React from "react";
import "./fileuploaddetails.css";
import { Button } from "primereact/button";
const FileUploadDetails = ({
  fileUploadStatus,
  setShowStats,
  isFromBulkUpdate,
  setData,
  setFileUploadDetails,
  setHeader,
  setDuplicateRows,
  setColor,
  setAddUnits,
}) => {
  return (
    <div className="fileuploaddetails">
      <div className="fileuploaddetailsinner">
        <button
          className="backicon"
          onClick={() => {
            if (isFromBulkUpdate) {
              setFileUploadDetails(false);
            } else {
              setAddUnits(false);
            }
          }}
        >
          <i
            className="pi pi-angle-left"
            style={{ fontSize: "1.5rem", color: "#323232" }}
          ></i>
        </button>
        <h1>SUCCESSFULLY ADDED</h1>
        <div className="successupload">
          <div
            className={
              fileUploadStatus?.newSimNumbers?.length > 0
                ? "simnumbershover"
                : "simnumbers"
            }
            style={{
              borderColor:
                fileUploadStatus?.newSimNumbers?.length < 1
                  ? "#E1E4F3"
                  : "#27AE60",
            }}
            onClick={() => {
              if (fileUploadStatus?.newSimNumbers?.length > 0) {
                setColor("success");
                setData(fileUploadStatus?.newSimNumbers || []);
                setFileUploadDetails(false);
                setHeader("SIM ADDED");
                setShowStats(true);
              }
            }}
          >
            <label>SIM NUMBERS</label>
            <h1>
              {fileUploadStatus?.newSimNumbers?.length > 0
                ? fileUploadStatus?.newSimNumbers?.length
                : "0"}
            </h1>
          </div>
          <div
            className={
              fileUploadStatus?.newIMEINumbers?.length > 0
                ? "imeinumbershover"
                : "imeinumbers"
            }
            style={{
              borderColor:
                fileUploadStatus?.newIMEINumbers?.length < 1
                  ? "#E1E4F3"
                  : "#27AE60",
            }}
            onClick={() => {
              if (fileUploadStatus?.newIMEINumbers?.length > 0) {
                setColor("success");
                setData(fileUploadStatus?.newIMEINumbers || []);
                setFileUploadDetails(false);
                setHeader("IMEI NUMBERS");
                setShowStats(true);
              }
            }}
          >
            <label>IMEI ADDED</label>
            <h1>
              {fileUploadStatus?.newIMEINumbers?.length > 0
                ? fileUploadStatus?.newIMEINumbers?.length
                : "0"}
            </h1>
          </div>
          <div
            className={
              fileUploadStatus?.noBoxNoAddedForSIMS?.length > 0
                ? "boxeshover"
                : "boxes"
            }
            style={{
              borderColor:
                fileUploadStatus?.noBoxNoAddedForSIMS?.length < 1
                  ? "#E1E4F3"
                  : "#27AE60",
            }}
            onClick={() => {
              if (fileUploadStatus?.noBoxNoAddedForSIMS?.length > 0) {
                setColor("success");
                setData(fileUploadStatus?.noBoxNoAddedForSIMS || []);
                setFileUploadDetails(false);
                setHeader("NO OF BOXES");
                setShowStats(true);
              }
            }}
          >
            <label>NO OF BOXES</label>
            <h1>
              {fileUploadStatus?.noBoxNoAddedForSIMS?.length > 0
                ? fileUploadStatus?.noBoxNoAddedForSIMS?.length
                : "0"}
            </h1>
          </div>
        </div>
        <h2>DUPLICATIONS</h2>
        <div className="duplications">
          <div
            className={
              fileUploadStatus?.existingSimNumbers?.length > 0
                ? "simnumbershover"
                : "simnumbers"
            }
            style={{
              borderColor:
                fileUploadStatus?.existingSimNumbers?.length < 1
                  ? "#E1E4F3"
                  : "#b3261e",
            }}
            onClick={() => {
              if (fileUploadStatus?.existingSimNumbers?.length > 0) {
                setData(fileUploadStatus?.existingSimNumbers || []);
                setColor("danger");
                setFileUploadDetails(false);
                setHeader("SIM DUPLICATIONS");
                setShowStats(true);
              }
            }}
          >
            <label>SIM DUPLICATIONS</label>
            <h1>
              {fileUploadStatus?.existingSimNumbers?.length > 0
                ? fileUploadStatus?.existingSimNumbers?.length
                : "0"}
            </h1>
          </div>
          <div
            className={
              fileUploadStatus?.existingSimNumbers?.length > 0
                ? "imeinumbershover"
                : "imeinumbers"
            }
            style={{
              borderColor:
                fileUploadStatus?.existingIMEINumbers?.length < 1
                  ? "#E1E4F3"
                  : "#b3261e",
            }}
            onClick={() => {
              if (fileUploadStatus?.existingIMEINumbers?.length > 0) {
                setData(fileUploadStatus?.existingIMEINumbers || []);
                setColor("danger");
                setFileUploadDetails(false);
                setHeader("IMEI DUPLICATONS");
                setShowStats(true);
              }
            }}
          >
            <label>IMEI DUPLICATIONS</label>
            <h1>
              {fileUploadStatus?.existingIMEINumbers?.length > 0
                ? fileUploadStatus?.existingIMEINumbers?.length
                : "0"}
            </h1>
          </div>
          <div
            className={
              fileUploadStatus?.noBoxNoAddedForSIMS?.length > 0
                ? "boxeshover"
                : "boxes"
            }
            style={{
              borderColor:
                fileUploadStatus?.noBoxNoAddedForSIMS?.length < 1
                  ? "#E1E4F3"
                  : "#b3261e",
            }}
            onClick={() => {
              if (fileUploadStatus?.noBoxNoAddedForSIMS?.length > 0) {
                setData(fileUploadStatus?.noBoxNoAddedForSIMS || []);
                setColor("danger");
                setFileUploadDetails(false);
                setHeader("NO OF BOXES");
                setShowStats(true);
              }
            }}
          >
            <label>NO BOX NUMBER ADDED</label>
            <h1>
              {fileUploadStatus?.noBoxNoAddedForSIMS?.length > 0
                ? fileUploadStatus?.noBoxNoAddedForSIMS?.length
                : "0"}
            </h1>
          </div>
        </div>
        <h2>ERRORS</h2>
        <div className="errors">
          <div
            className={
              fileUploadStatus?.emptySIMRows?.length > 0
                ? "simnumbershover"
                : "simnumbers"
            }
            style={{
              borderColor:
                fileUploadStatus?.emptySIMRows?.length < 1
                  ? "#E1E4F3"
                  : "#b3261e",
            }}
            onClick={() => {
              if (fileUploadStatus?.emptySIMRows?.length > 0) {
                setData(fileUploadStatus?.emptySIMRows || []);
                setColor("danger");
                setFileUploadDetails(false);
                setHeader("EMPTY SIM ROWS");
                setShowStats(true);
              }
            }}
          >
            <label>EMPTY SIM ROWS</label>
            <h1>
              {fileUploadStatus?.emptySIMRows?.length > 0
                ? fileUploadStatus?.emptySIMRows?.length
                : "0"}
            </h1>
          </div>
          <div
            className={
              fileUploadStatus?.invalidIMEILength?.length > 0
                ? "imeinumbershover"
                : "imeinumbers"
            }
            style={{
              borderColor:
                fileUploadStatus?.invalidIMEILength?.length < 1
                  ? "#E1E4F3"
                  : "#b3261e",
            }}
            onClick={() => {
              if (fileUploadStatus?.invalidIMEILength?.length > 0) {
                setData(fileUploadStatus?.invalidIMEILength || []);
                setColor("danger");
                setFileUploadDetails(false);
                setHeader("INVALID IMEI LENGTH");
                setShowStats(true);
              }
            }}
          >
            <label>INVALID IMEI LENGTH</label>
            <h1>
              {fileUploadStatus?.invalidIMEILength?.length > 0
                ? fileUploadStatus?.invalidIMEILength?.length
                : "0"}
            </h1>
          </div>
          <div
            className={
              fileUploadStatus?.duplicateRows?.length > 0
                ? "boxeshover"
                : "boxes"
            }
            style={{
              borderColor:
                fileUploadStatus?.duplicateRows?.length < 1
                  ? "#E1E4F3"
                  : "#b3261e",
            }}
            onClick={() => {
              if (fileUploadStatus?.duplicateRows?.length > 0) {
                setColor("danger");
                setData([]);
                setDuplicateRows(fileUploadStatus?.duplicateRows || []);
                setFileUploadDetails(false);
                setHeader("DUPLICATE ROWS");
                setShowStats(true);
              }
            }}
          >
            <label>DUPLICATED ROWS</label>
            <h1>
              {fileUploadStatus?.duplicateRows?.length > 0
                ? fileUploadStatus?.duplicateRows?.length
                : "0"}
            </h1>
          </div>
        </div>
      </div>
      <div className="fileuploaddetailbtn">
        <Button label="Back" className="backbtn" />
      </div>
    </div>
  );
};

export default FileUploadDetails;
